import {Filter} from '../../ParticipationFunctions/Filtering';
import {CommunityPlantedDBHFilter} from '../../ParticipationColumns/CommunityEvents/CommunityPlantedDBH';
import {CommunityTreesPlantedFilter} from '../../ParticipationColumns/CommunityEvents/CommunityTreesPlanted';
import {ProjectCommunityTreesPlantedFilter} from '../../ParticipationColumns/CommunityEvents/ProjectCommunityTreesPlanted';
import {DAMTagFilter} from '../../ParticipationColumns/Shared/DAMTag';
import {DeleteParticipationFilter} from '../../ParticipationColumns/Shared/DeleteParticipation';
import {EverythingValidatedFilter} from '../../ParticipationColumns/Shared/EverythingValidated';
import {ProposalFilter} from '../../ParticipationColumns/Shared/ProposalColumn';
import {DemoProjectColumnFilter} from '../../ParticipationColumns/Shared/DemoProjectColumn';
import {ExcludedFilter} from '../../ParticipationColumns/Shared/Excluded';
import {FundedYearFilter} from '../../ParticipationColumns/Shared/FundedYear';
import {HasHeroFilter} from '../../ParticipationColumns/Shared/HasHero';
import {HasTreeSpeciesFilter} from '../../ParticipationColumns/Shared/HasTreeSpecies';
import {ImageCountFilter} from '../../ParticipationColumns/Shared/ImageCount';
import {ImagesValidatedFilter} from '../../ParticipationColumns/Shared/ImagesValidated';
import {ImpactStoryCompletedFilter} from '../../ParticipationColumns/Shared/ImpactStoryCompleted';
import {ImpactStoryInProgressFilter} from '../../ParticipationColumns/Shared/ImpactStoryInProgress';
import {MapFilter} from '../../ParticipationColumns/Shared/Map';
import {ParticipationIdFilter} from '../../ParticipationColumns/Shared/ParticipationId';
import {PlantingPartnerFilter} from '../../ParticipationColumns/Shared/PlantingPartner';
import {ProjectIdFilter} from '../../ParticipationColumns/Shared/ProjectId';
import {ProjectLocationFilter} from '../../ParticipationColumns/Shared/ProjectLocation';
import {ProjectNameFilter} from '../../ParticipationColumns/Shared/ProjectName';
import {ProjectStatusFilter} from '../../ParticipationColumns/Shared/ProjectStatus';
import {ProjectTypeFilter} from '../../ParticipationColumns/Shared/ProjectTypeColumn';
import {ReasonForPlantingFilter} from '../../ParticipationColumns/Shared/ReasonForPlanting';
import {ShowOnDateFilter} from '../../ParticipationColumns/Shared/ShowOnDate';
import { ProjectYearsFilter } from '../../ParticipationColumns/Shared/ProjectYears';
import {VisibleToParticipantFilter} from '../../ParticipationColumns/Shared/VisibleToParticipant';

export function MembershipTreesFilter({
    filter,
    updateFilter
}: {
    filter: Filter;
    updateFilter: (filter: Filter) => void;
}) {
    return (
        <tr>
            <DeleteParticipationFilter />
            <ExcludedFilter filter={filter} updateFilter={updateFilter} />
            <EverythingValidatedFilter filter={filter} updateFilter={updateFilter} />
            <ProposalFilter filter={filter} updateFilter={updateFilter} />
            <DemoProjectColumnFilter filter={filter} updateFilter={updateFilter} />
            <VisibleToParticipantFilter filter={filter} updateFilter={updateFilter} />
            <ParticipationIdFilter filter={filter} updateFilter={updateFilter} />
            <FundedYearFilter filter={filter} updateFilter={updateFilter} />
            <CommunityTreesPlantedFilter filter={filter} updateFilter={updateFilter} />
            <ShowOnDateFilter filter={filter} updateFilter={updateFilter} />
            <ProjectIdFilter filter={filter} updateFilter={updateFilter} />
            <ProjectTypeFilter filter={filter} updateFilter={updateFilter} />
            <ProjectNameFilter filter={filter} updateFilter={updateFilter} />
            <ProjectStatusFilter filter={filter} updateFilter={updateFilter} />
            <ProjectLocationFilter filter={filter} updateFilter={updateFilter} />
            <MapFilter filter={filter} updateFilter={updateFilter} />
            <ProjectYearsFilter filter={filter} updateFilter={updateFilter} />
            <ReasonForPlantingFilter filter={filter} updateFilter={updateFilter} />
            <ImpactStoryInProgressFilter filter={filter} updateFilter={updateFilter} />
            <ImpactStoryCompletedFilter filter={filter} updateFilter={updateFilter} />
            <PlantingPartnerFilter filter={filter} updateFilter={updateFilter} />
            <ProjectCommunityTreesPlantedFilter filter={filter} updateFilter={updateFilter} />
            <CommunityPlantedDBHFilter filter={filter} updateFilter={updateFilter} />
            <HasTreeSpeciesFilter filter={filter} updateFilter={updateFilter} />
            <DAMTagFilter filter={filter} updateFilter={updateFilter} />
            <ImagesValidatedFilter filter={filter} updateFilter={updateFilter} />
            <ImageCountFilter filter={filter} updateFilter={updateFilter} />
            <HasHeroFilter filter={filter} updateFilter={updateFilter} />
        </tr>
    );
}
